import React from 'react';
import {OcrMode, useOcrModeLabels} from "../../../../models/ocr.models";
import {useTranslation} from "react-i18next";
import SelectWithFallback from "../../../../components/documents-digitization/SelectWithFallback";

interface OptionsPanelProps {
    mode: OcrMode,
    onChangeOption: (mode: OcrMode) => void;
}

const OptionsPanel = ({mode, onChangeOption}: OptionsPanelProps) => {
    const ocrModeLabels = useOcrModeLabels();
    const { t } = useTranslation();

    const options = Object.entries(ocrModeLabels).map(
        ([key, { label }]) => ({value: key, label: label})
    );

    return (
        <SelectWithFallback
            label={t('ocr.options.ocrMode')}
            options={options}
            value={mode}
            onChange={(value) => onChangeOption(value as OcrMode)}
        />
    );
};

export default OptionsPanel;